// extracted by mini-css-extract-plugin
var _1 = "AttachedRequests-moduleAttachedRequests__CHENa MultiValuedList-moduleMultiValuedList__ZJwbV";
var _2 = "AttachedRequests-moduleitemsList___3wvA MultiValuedListItems-moduleMultiValuedListItems__sFyGz";
export { _1 as "AttachedRequests", _2 as "itemsList" }
